import { FormValues } from "../components/approvalDecisionsModal/ApprovalFlowForm";
import { ApprovalDecision } from "../../../types";

type ApprovalPayload = {
	approval?: { uuid: string };
	approvalTemplateStage?: { uuid: string };
	note?: string | null;
	assignedToUserId?: { uuid: string } | null;
	dtDecision?: string;
	isApproved?: string | null;
	decidedByUserId?: { uuid: string } | null;
};

const handleFormatApprovalWorkflowPayload = (
	formData: FormValues,
	approvalDecisions: ApprovalDecision,
	userUuid: string | null,
) => {
	const stages = approvalDecisions.stages;

	// Map through each stage and create the appropriate payload
	const operations = stages
		.map((stage) => {
			const stepNumber = stage.ApprovalTemplateStages.step;
			const stageFormData = formData[stepNumber];
			// Skip if no form data for this stage
			if (!stageFormData) {
				return null;
			}

			// Determine if this is a POST or PUT based on ApprovalDecisions.uuid
			const isUpdatingApprovalDecision =
				stage.ApprovalDecisions.uuid !== null;
			const method = isUpdatingApprovalDecision ? "PUT" : "POST";

			// FORM VALUES TO VARIABLES
			const formNote = stageFormData.note || null;
			const formHasApprovalDecisionValue =
				stageFormData.actionButtonSelected;
			const formAssignedToUuid = stageFormData.assignedTo?.uuid || null;

			// VALUES FROM ORIGINAL STAGE DATA
			const originalNote = stage.ApprovalDecisions.note;
			const originalHasApprovalDecisionValue =
				stage.ApprovalDecisions.isApproved;
			const originalAssignedToUuid = stage.AssignedTo.uuid;

			let payload: ApprovalPayload = {};

			// has the note for this stage been changed? return true/false
			const didNoteChanged = formNote !== originalNote;

			// has the assigned to for this stage been changed? return true/false
			const didAssignedToChanged =
				(formAssignedToUuid || null) !==
				(originalAssignedToUuid || null);

			// has the approval decision to for this stage been changed? return true/false
			const didApprovalStatusChange =
				(formHasApprovalDecisionValue || null) !==
				(originalHasApprovalDecisionValue || null);

			// For POST requests, skip if all three fields are null
			if (
				!didNoteChanged &&
				!didAssignedToChanged &&
				!didApprovalStatusChange
			) {
				return null;
			}

			// if the stage 2 is PRE APPROVED
			if (stepNumber === "2" && stage.isPreApproved) {
				// in this case, you cannot change the isApproved value or decidedBy or dtDecision
				if (didNoteChanged) {
					payload.approval = { uuid: stage.Approvals.uuid };
					payload.approvalTemplateStage = {
						uuid: stage.ApprovalTemplateStages.uuid,
					};
					payload.note = formNote;
				}
				if (didAssignedToChanged) {
					payload.approval = { uuid: stage.Approvals.uuid };
					payload.approvalTemplateStage = {
						uuid: stage.ApprovalTemplateStages.uuid,
					};
					payload.assignedToUserId =
						stageFormData.assignedTo?.uuid &&
						stageFormData.assignedTo.name !== ""
							? { uuid: stageFormData.assignedTo.uuid }
							: null;
				}
			} else {
				payload = {
					approval: { uuid: stage.Approvals.uuid },
					approvalTemplateStage: {
						uuid: stage.ApprovalTemplateStages.uuid,
					},
				};

				if (didApprovalStatusChange) {
					payload.dtDecision = "NOW()";
					payload.isApproved = formHasApprovalDecisionValue;
					if (userUuid) {
						payload.decidedByUserId = { uuid: userUuid };
					}
				}

				if (didAssignedToChanged && formAssignedToUuid) {
					payload.assignedToUserId = { uuid: formAssignedToUuid };
				}

				if (didNoteChanged) {
					payload.note = formNote;
				}
			}

			let route;

			if (method === "POST") {
				route = `/approval-decisions`;
			} else if (method === "PUT") {
				route = `/approval-decisions/${stage.ApprovalDecisions.uuid}`;
			}

			return {
				method,
				payload,
				route: route,
			};
		})
		.filter(Boolean);

	return operations;
};

export default handleFormatApprovalWorkflowPayload;
